export const idleLogoutTime = 1000 * 60 * 10;
